import PortableText from '@otovo/shared/components/Sanity/PortableTextComponents';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { Otovo$Locale } from '@otovo/shared/types/otovoweb';
import { Sanity$CalloutWithInformationEntries } from '@otovo/shared/types/sanityTypes';
import { useRouter } from 'next/router';
import CTAButton from '../../v2/CTAButton';
import { routeToHref } from '../routeToHrefUtil';

type Props = {
  content: Sanity$CalloutWithInformationEntries;
};

const CalloutWithInformationEntries = ({ content }: Props) => {
  const config = useGlobalConfig();
  const locale = useRouter().locale as Otovo$Locale;
  const informationEntries = content.informationEntries || [];
  return (
    <section className="bg-surface" data-testid="header-centered">
      <div className="mx-auto max-w-8xl px-4 py-16 md:px-6 md:py-20 lg:px-16 lg:py-24 xl:py-32">
        <div className="flex justify-center">
          <div className="max-w-2xl space-y-3 text-center xl:max-w-3xl">
            {!!content.tagline && (
              <span className="block caption-m text-subheading">
                {content.tagline}
              </span>
            )}
            <h2 className="text-2xl font-semibold text-pretty text-heading md:text-3xl lg:text-4xl">
              {content.heading}
            </h2>
          </div>
        </div>
        <div className="mx-auto max-w-2xl">
          {!!informationEntries.length && (
            <hr className="border-px mt-8 mb-14 border-grey-10" />
          )}
          {informationEntries.map((informationEntry, index) => (
            <div key={informationEntry._key}>
              <h3 className="mb-3 text-lg font-semibold">
                {informationEntry.title}
              </h3>
              <PortableText value={informationEntry.body} />
              {index < informationEntries.length - 1 && (
                <hr className="border-px mt-8 mb-14 border-grey-10" />
              )}
            </div>
          ))}
          {content.cta && (
            <div className="mx-auto md:max-w-96">
              <CTAButton
                href={routeToHref(
                  content.cta.route,
                  config.BU_CONFIG.market,
                  locale,
                )}
                className="mt-6 block sm:mt-12"
              >
                {content.cta.title}
              </CTAButton>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default CalloutWithInformationEntries;
